export function formatDate(d) {
  if (!d) return "";
  return String(d).split("T")[0];
}

export function todayStr() {
  return new Date().toISOString().split("T")[0];
}

export function weekAgoStr() {
  const d = new Date();
  d.setDate(d.getDate() - 7);
  return d.toISOString().split("T")[0];
}

export function fmtMoney(n, fractionDigits = 2) {
  const num = Number(n);
  if (!Number.isFinite(num)) return "—";
  return num.toLocaleString("en", { minimumFractionDigits: fractionDigits });
}

export function sanitiseFilename(s) {
  return (
    String(s || "")
      .trim()
      .replace(/[^A-Za-z0-9._-]+/g, "_")
      .replace(/^_+|_+$/g, "") || "gr"
  );
}

export function filenameFor(gr) {
  return `${sanitiseFilename(
    gr?.transaction_key || `GR-${gr?.gr_header?.doc_entry}`
  )}.json`;
}
